import useApiRequest from 'api/useApiRequest';
import { fetchCurrentUser } from 'api/services/userService';

const useUser = () => {
  const { request } = useApiRequest();

  const getCurrentUser = async (params) => {
    const { data } = await fetchCurrentUser(request, params);
    return data;
  };

  return { getCurrentUser };
};

export default useUser;
